import {HOURS} from '../../../../../CodeMaster'
import {numberOrZero} from '../../../../../stringHelper/stringHelpers'
import {Nullable} from '../../../../../app/TypeHelpers'

export const getMaxReservationTimeUpperLimit = (start: number, end: number): number => {
    return (end - start + 24) % 24
}

export const getSelectableHours = (start: number, end: number): HOURS[] => {
    if (start <= end) {
        return (
            HOURS.values()
                .filter(item => {
                    const itemValueNum = numberOrZero(item.value)
                    return start < itemValueNum && itemValueNum <= end
                })
        )
    }
    const beforeHours = HOURS.values()
        .filter(item => {
            return start < numberOrZero(item.value)
        })
    const afterHours = HOURS.values()
        .filter(item => {
            return end >= numberOrZero(item.value)
        })
    return [...beforeHours, ...afterHours]
}

interface SelectableHoursAndMaxReservationTimeUpper {
    maxReservationTimeUpperLimit: number
    selectableHours: HOURS[]
}

export const calcSelectableHoursAndUpperLimit = (
    startHour: Nullable<HOURS>,
    endHour: Nullable<HOURS>,
    selectableEndHour: Nullable<HOURS>,
): SelectableHoursAndMaxReservationTimeUpper => {
    let maxReservationTimeUpperLimit: number = 0
    let selectableHours: HOURS[] = []
    if (startHour !== null && endHour !== null && selectableEndHour !== null) {
        const startHourNum: number = numberOrZero(startHour.value)
        const endHourNum: number = numberOrZero(endHour.value)
        const selectableEndHourNum: number = numberOrZero(selectableEndHour.value)
        maxReservationTimeUpperLimit = getMaxReservationTimeUpperLimit(startHourNum, endHourNum)
        selectableHours = getSelectableHours(startHourNum, selectableEndHourNum)
    }
    return {
        maxReservationTimeUpperLimit: maxReservationTimeUpperLimit,
        selectableHours: selectableHours,
    }
}
